export default function CalculateHitLocation(
    fieldCoords,
    imageWidth,
    imageHeight
) {
    const percentChange = imageWidth / 500
    const PLOT_LOCATION_MAP = {
        imageWidth: 500 * percentChange,
        imageHeight: 500 * percentChange,
        ft410y: 58 * percentChange,
        home: {
            x: 252 * percentChange,
            y: 409 * percentChange,
        },
        radius_small: 7 * percentChange,
        radius_big: 20 * percentChange,
    }
    const { x } = fieldCoords
    const { y } = fieldCoords

    const direction = parseFloat(null)
    const distance = parseFloat(null)
    const ft410y = PLOT_LOCATION_MAP.home.y - PLOT_LOCATION_MAP.ft410y
    let hitXFromOrigin
    let hitYFromOrigin
    if ((x || x === 0) && (y || y === 0)) {
        hitXFromOrigin = (ft410y / 410) * parseFloat(x)
        hitYFromOrigin = (ft410y / 410) * parseFloat(y)
    } else {
        let normalizedDistance = (ft410y / 410) * distance
        normalizedDistance *= imageWidth / PLOT_LOCATION_MAP.imageWidth
        hitXFromOrigin = normalizedDistance * Math.sin(direction * 0.0174532925)
        hitYFromOrigin = normalizedDistance * Math.cos(direction * 0.0174532925)
    }

    let hitX = PLOT_LOCATION_MAP.home.x + hitXFromOrigin
    let hitY = PLOT_LOCATION_MAP.home.y - hitYFromOrigin
    if (hitY < 15) {
        hitY = 15
    } else if (hitY > imageHeight - 15) {
        hitY = imageHeight - 15
    }

    if (hitX < 15) {
        hitX = 15
    } else if (hitX > imageWidth - 15) {
        hitX = imageWidth - 15
    }

    return {
        x: hitX,
        y: hitY,
    }
}
